import styled, { css } from 'styled-components'

import config from '../config'

const Title = styled.h1`
  font-weight: bold;
  font-size: 40px;
  line-height: 1.15;
  font-family: 'Guardian Egyptian Web';
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  color: ${config.colors.blue};
  margin: 0;

  @media (max-width: 480px) {
    font-size: 30px;
  }

  ${props =>
    props.align === 'center' &&
    css`
      text-align: center;
    `}

  ${props =>
    props.margin &&
    css`
      margin-bottom: 1.15rem;
    `}

  ${props =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${props =>
    (props.theme.name === 'blue' ||
      props.theme.name === 'platinum' ||
      props.theme.name === 'multi') &&
    css`
      font-family: 'BentonSans';
      font-weight: 900;
      text-transform: uppercase;
    `}

  ${props =>
    props.theme.name === 'payback' &&
    css`
      font-size: 35px;
      color: #0046aa;
      font-family: 'PAYBACK_Regular';
      font-weight: normal;
      text-transform: uppercase;
    `}

  ${props =>
    (props.theme.name === 'blue' || props.theme.name === 'multi') &&
    css`
      font-size: 35px;
    `}

  ${props =>
    props.theme.name === 'platinum' &&
    css`
      color: #53565a;
    `}

  ${props =>
    props.inheritColor &&
    css`
      color: inherit;
      color: red;
    `}

`

export default Title
